import { Link, router } from "@inertiajs/react";
import { AppShell, Button, Group, Image, ScrollArea, Stack } from "@mantine/core";
import { IconLogout } from "@tabler/icons-react";
import type { PropsWithChildren } from "react";
import { YearContextSelect } from "../components/select/YearContextSelect";
import { useDisableNavbar, useRole, useUser, useVersion } from "../hooks/useProps";
import { Role } from "../models/enums/role";
import { destroy_user_session_path, new_user_session_path, root_path } from "../routes";
import { Footer } from "./footer/Footer";
import { Navbar } from "./navbar/Navbar";

type DefaultLayoutProps = PropsWithChildren;

export function DefaultLayout({ children }: DefaultLayoutProps) {
  const role = useRole();
  const user = useUser();
  const disableNavbar = useDisableNavbar();
  const version = useVersion();
  const showNavbar = role ? [Role.ADMIN, Role.COACH].includes(role) && !disableNavbar : false;
  const logoLink = role ? root_path() : new_user_session_path();

  return (
    <AppShell
      header={{ height: 75 }}
      navbar={{
        width: 300,
        collapsed: { desktop: !showNavbar, mobile: !showNavbar },
        breakpoint: "sm",
      }}
      footer={{
        height: 50,
      }}
      padding="xl"
    >
      <AppShell.Header>
        <Group h="100%" pl="md" pr="sm" justify="space-between">
          <Link href={logoLink}>
            <Image h={45} w="auto" src="/logo.png" fit="contain" />
          </Link>
          <Group>
            <YearContextSelect />
            {user && (
              <Button
                onClick={() => router.delete(destroy_user_session_path())}
                variant="light"
                color="zli-blue"
                leftSection={<IconLogout />}
              >
                Ausloggen
              </Button>
            )}
          </Group>
        </Group>
      </AppShell.Header>

      {showNavbar && (
        <AppShell.Navbar>
          <ScrollArea type="never">
            <Stack justify="space-between" h="100%">
              <Navbar />
            </Stack>
          </ScrollArea>
        </AppShell.Navbar>
      )}
      <AppShell.Main>{children}</AppShell.Main>
      <AppShell.Footer>
        <Footer version={version} />
      </AppShell.Footer>
    </AppShell>
  );
}
